import { UserState } from './../../users/user.state';
import { IOrganization } from './../../models/organization';
import { ILoginInformation } from './../../models/login-information';
import { IMember } from './../../models/member';
import { environment } from './../../../environments/environment';

import { UserService } from './../user/user.service';
import { Injectable } from '@angular/core';
import { IDataService } from './data-service.interface';
import { Observable, of, throwError } from 'rxjs';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { UrlService } from '../url.service';
import { Store, Select } from '@ngxs/store';
import { User } from '../../users/user.actions';

@Injectable({
  providedIn: 'root',
})
export abstract class DataService<TModel> implements IDataService<TModel> {
  baseUri = environment.dbApi.baseUrl;
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  protected collectionname: string;

  protected loginInformation: ILoginInformation;
  protected user: IMember;
  protected organization: IOrganization;

  protected itemsCollection: Array<TModel>;

  @Select(UserState.getCurrentOrganization)
  organization$: Observable<IOrganization>;

  @Select(UserState.getCurrentUser)
  member$: Observable<IMember>;

  setCollectionName(collectionName: string): void {
    this.collectionname = collectionName;
  }

  delete(id: string): Observable<any> {
    const url = `${this.baseUri}/${this.collectionname}/delete/${id}`;
    return this.http
      .delete(url, { headers: this.headers })
      .pipe(catchError(this.errorMgmt));
  }
  list(): Observable<Array<TModel>> {
    const url = `${this.baseUri}/${this.collectionname}`;
    return this.http.get<Array<TModel>>(`${url}`);
  }
  get(id: string): Observable<TModel> {
    const url = `${this.baseUri}/${this.collectionname}/read/${id}`;
    return this.http.get<TModel>(url, { headers: this.headers }).pipe(
      map((res: TModel) => res || ({} as TModel)),
      catchError(this.errorMgmt)
    );
  }

  byOrganization(organizationId: string): Observable<Array<TModel>> {
    const url = `${this.baseUri}/${this.collectionname}/organization/${organizationId}`;
    return this.http.get<Array<TModel>>(url, { headers: this.headers }).pipe(
      map((res: Array<TModel>) => {
        res.forEach((item) => {
          this.setId(item);
        });
        return res || ({} as Array<TModel>);
      }),
      catchError(this.errorMgmt)
    );
  }

  byUser(entityId: string): Observable<Array<TModel>> {
    const url = `${this.baseUri}/${this.collectionname}/user/${entityId}`;
    return this.http.get<Array<TModel>>(url, { headers: this.headers }).pipe(
      map((res: Array<TModel>) => {
        res.forEach((item) => {
          this.setId(item);
        });
        return res || ({} as Array<TModel>);
      }),
      catchError(this.errorMgmt)
    );
  }

  setId(item): void {
    if (item && item['_id'] && !item.id) {
      item['id'] = item['_id'];
    }
  }
  create(data: TModel): Observable<TModel> {
    const url = `${this.baseUri}/${this.collectionname}/create`;
    if (!data['createdDate']) {
      data['createdDate'] = new Date().toISOString();
    }
    return this.http.post<TModel>(url, data).pipe(
      map((item) => {
        this.setId(item);
        return item;
      }),
      catchError(this.errorMgmt)
    );
  }
  update(id: any, data: TModel): Observable<TModel> {
    const url = `${this.baseUri}/${this.collectionname}/update/${id}`;
    return this.http.patch<TModel>(url, data, { headers: this.headers }).pipe(
      map((item) => {
        this.setId(item);
        return item;
      }),
      catchError(this.errorMgmt)
    );
  }

  reference(ref) {
    if (ref) {
      ref.orderBy('id', 'asc');
    }
  }

  validate(item: any): Observable<boolean> {
    throw new Error('Method not implemented.');
  }
  filter(field: string, value: any): Observable<Array<TModel>> {
    // return this.http.get<TModel>(url, data, { headers: this.headers }).pipe(
    //   catch
    return of([] as Array<TModel>);
  }

  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent || error.error.message) {
      // Get client-side error
      errorMessage = error.error.message;
      // } else if(error.error.message) {
      //     errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    return throwError(errorMessage);
  }

  constructor(
    protected http: HttpClient,
    protected urlService: UrlService,
    protected userService: UserService,
    protected store: Store
  ) {
    this.organization$.subscribe((org) => {
      this.organization = org;
    });

    this.member$.subscribe((member) => {
      this.user = member;
    });

    if (this.user) return;
    // TODO: move this to a userService and out of state.

    try {
      this.userService.getCurrentUser().then(
        (user) => {
          // console.log('in getCurentUser', this.user, this.organization)
          // console.log('this.user', this.user);
          // console.log('this.organization', this.organization);

          if (!!this.user && !!this.organization) return;

          if (!user || user.email) return;
          this.store
            .dispatch(new User.Actions.GetLoginInformation(user?.email))
            .subscribe((response) => {});
        }
        // (error) => console.log('no user logged in', error)
      );
    } catch (e) {}
  }
}
